import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col gap-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CategoryPill = _resolveComponent("CategoryPill")!
  const _component_RfpCategorySelect = _resolveComponent("RfpCategorySelect")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.mode === 'view')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shownCategories, (category) => {
            return (_openBlock(), _createBlock(_component_CategoryPill, {
              key: category.id
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(category.title), 1)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]))
      : (_ctx.mode === 'edit')
        ? (_openBlock(), _createBlock(_component_RfpCategorySelect, {
            key: 1,
            modelValue: _ctx.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
            categories: _ctx.allCategories
          }, null, 8, ["modelValue", "categories"]))
        : _createCommentVNode("", true)
  ]))
}